import { applyMiddleware, combineReducers, compose, createStore } from 'redux';

import createSagaMidleware from 'redux-saga';

import reducers from './reducers';
import actions from './actions';
import rootSaga from './sagas/rootSaga';

const configureStore = (initialState) => {
  const saga = createSagaMidleware();

  // TODO: move router reducer into appstate
  const staticReducers = {
    ...reducers,
  };

  const createReducer = (asyncReducers) =>
    combineReducers({
      ...staticReducers,
      ...asyncReducers,
    });

  const actionCreators = {
    ...actions,
  };

  const middlewares = [saga];

  const composeEnhancers = (() => {
    const compose_ =
      typeof window !== 'undefined' &&
      window &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

    if (process.env.NODE_ENV === 'development' && compose_) {
      return compose_({ actionCreators });
    }

    return compose;
  })();

  const enhancer = composeEnhancers(applyMiddleware(...middlewares));
  const store = createStore(createReducer(), initialState, enhancer);

  // Add a dictionary to keep track of the registered async reducers
  store.asyncReducers = {};

  // Create an inject reducer function
  // This function adds the async reducer, and creates a new combined reducer
  store.injectReducer = (key, asyncReducer) => {
    store.asyncReducers[key] = asyncReducer;
    store.replaceReducer(createReducer(this.asyncReducers));
  };

  saga.run(rootSaga);

  store.registerSagas = (...sagas) => {
    sagas.forEach(saga.run);
  };

  return store;
};

export default configureStore;
